



































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import Calendar from "../general/Calendar.vue";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";

import BirthdayBookingInfoJson from "../../shared/BirthdayBookingInfoJson";
import BirthdayTimeSlotJson from "../../shared/BirthdayTimeSlotJson";
import { BirthdayStaffAvailableStatus } from "../../shared/BirthdayStaffAvailableStatus";
import BirthdayStaffAvailableJson from "../../shared/BirthdayStaffAvailableJson";

export default Vue.extend({
  name: "BirthdaysStaffFreeDates",
  components: {
    Loading,
    Calendar,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      loading: false,
      birthdayBookingInfo: null as BirthdayBookingInfoJson | null,
      staffAvailable: null as BirthdayStaffAvailableJson[] | null,
      BirthdayStaffAvailableStatus: {
        open: "Frei zur Buchung",
        reserved: "Reserviert",
        booked: "Gebucht",
      },
      currentCalenderYearMonth: null as [number, number] | null,
      dateToShow: null as Date | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadBirthdayInfo();
      this.loadStaffAvailable();
    },

    async loadBirthdayInfo() {
      try {
        let rc = RestClient;
        this.birthdayBookingInfo = await rc.getBirthdayBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadStaffAvailable() {
      this.staffAvailable = null;

      try {
        this.staffAvailable = await this.restClient.getBirthdayStaffAvailability(this.loginId);
      } catch (e) {
        alert(e.message);
      }
    },

    async addFreeDate(item: CalendarEventJson) {
      //let date = DateFormatter.formatUSDate(dayDate)

      var data = {
        ID: null,
        staffId: this.loginId,
        beginDateTime: item.beginDateTime,
        endDateTime: item.endDateTime,
        status: BirthdayStaffAvailableStatus.open,
      };

      try {
        this.staffAvailable = null;
        await this.restClient.addBirthdayStaffAvailability(data);
        this.loadStaffAvailable();
      } catch (e) {
        alert(e.message);
        this.loadStaffAvailable();
      }
    },

    async removeFreeDate(item: CalendarEventJson) {
      if (this.staffAvailable != null) {
        //var date = DateFormatter.formatUSDate(dayDate)

        //let timeSlotBeginDateTime = new Date(date + " " + timeSlot.beginTime)
        var id = this.staffAvailable.find(
          (availableSlot) =>
            DateFormatter.formatISODateTime(new Date(availableSlot.beginDateTime)) == item.beginDateTime
        )?.ID;
        if (id) {
          var data = {
            ID: id,
            staffId: this.loginId,
            beginDateTime: item.beginDateTime,
            endDateTime: item.endDateTime,
            status: BirthdayStaffAvailableStatus.open,
          };

          try {
            this.staffAvailable = null;
            await this.restClient.deleteBirthdayStaffAvailability(data);
            this.loadStaffAvailable();
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async removeFreeDateById(id: number) {
      if (this.staffAvailable != null) {
        var item = this.staffAvailable.find((i) => i.ID == id);
        if (item !== undefined) {
          var data = {
            ID: id,
            staffId: this.loginId,
            beginDateTime: item.beginDateTime,
            endDateTime: item.endDateTime,
            status: BirthdayStaffAvailableStatus.open,
          };

          try {
            this.staffAvailable = null;
            await this.restClient.deleteBirthdayStaffAvailability(data);
            this.loadStaffAvailable();
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    getCalendarEvents() {
      var events: CalendarEventJson[] = [];
      let today = new Date();

      if (this.birthdayBookingInfo != null && this.currentCalenderYearMonth != null) {
        if (
          (today.getFullYear() == this.currentCalenderYearMonth[0] &&
            today.getMonth() <= this.currentCalenderYearMonth[1]) ||
          today.getFullYear() < this.currentCalenderYearMonth[0]
        ) {
          let firstDate = 1;
          let lastDate = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1] + 1, 0).getDate();

          if (
            today.getFullYear() == this.currentCalenderYearMonth[0] &&
            today.getMonth() == this.currentCalenderYearMonth[1]
          ) {
            firstDate = today.getDate() + 1;
          }

          while (firstDate <= lastDate) {
            let customTimeSlotsToday;

            let currentDate = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1], firstDate);

            var day = currentDate.getDay();

            if (day > 0 && day < 6) {
              customTimeSlotsToday = this.birthdayBookingInfo.customTimeSlots.filter(
                (item) => item.isWeekendOnly == false
              );
            } else {
              customTimeSlotsToday = this.birthdayBookingInfo.customTimeSlots;
            }

            for (let j in customTimeSlotsToday) {
              let beginTime = customTimeSlotsToday[j].beginTime;
              let endTime = customTimeSlotsToday[j].endTime;

              let event: CalendarEventJson = {
                title: "",
                beginDateTime: "",
                endDateTime: "",
                state: "",
                eventData: {},
              };

              event.title = "";
              event.beginDateTime = DateFormatter.formatISODate(currentDate) + "T" + beginTime;
              event.endDateTime = DateFormatter.formatISODate(currentDate) + "T" + endTime;
              event.state = "";

              event.eventData = customTimeSlotsToday[j];

              events.push(event);
            }

            firstDate++;
          }
        }
      }

      return events;
    },

    calenderCurrentYearMonth(year: number, month: number) {
      this.currentCalenderYearMonth = [year, month];
    },

    jumpToDateInCal(date: Date) {
      this.dateToShow = date;
    },

    isStaffAvailable(beginDateTime: string) {
      if (this.staffAvailable != null) {
        //let timeSlotBeginDateTime = new Date(DateFormatter.formatUSDate(dayDate) + " " + timeSlotBegin)

        if (
          this.staffAvailable.find(
            (availableSlot) => DateFormatter.formatISODateTime(new Date(availableSlot.beginDateTime)) == beginDateTime
          ) !== undefined
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    isStatusOpen(beginDateTime: string) {
      if (this.staffAvailable != null) {
        //let timeSlotBeginDateTime = new Date(DateFormatter.formatUSDate(dayDate) + " " + timeSlotBegin)

        var freeTimeSlot = this.staffAvailable.find(
          (availableSlot) => DateFormatter.formatISODateTime(new Date(availableSlot.beginDateTime)) == beginDateTime
        );
        if (freeTimeSlot !== undefined) {
          if (freeTimeSlot.status == "open") {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },

    customTimeSlotsToday(dayDate: Date): object | undefined {
      if (this.birthdayBookingInfo != null) {
        var customTimeSlotsToday;
        var day = dayDate.getDay();

        if (day > 0 && day < 6) {
          customTimeSlotsToday = this.birthdayBookingInfo.customTimeSlots.filter((item) => item.isWeekendOnly == false);
        } else {
          customTimeSlotsToday = this.birthdayBookingInfo.customTimeSlots;
        }

        return customTimeSlotsToday;
      }
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    upcomingStaffAvailable(): BirthdayStaffAvailableJson[] | null | undefined {
      if (this.staffAvailable != null) {
        var today = new Date().setHours(0, 0, 0, 0);
        var upcomingStaffAvailable = this.staffAvailable.filter(
          (i) => new Date(i.beginDateTime).setHours(0, 0, 0, 0) > today
        );
        return upcomingStaffAvailable;
      }
    },
  },
});
